module.exports = __webpack_public_path__ + "img/tutorial2.f66c1b7b.png";